import type { LeadsSearchTableData, LeadsSearchRow } from "app/pages/sales-intelligence/modules/leads-search/types";

import { useActiveTabLeadsDetailedResults } from "./useActiveTabLeadsDetailedResults";
import { useEnrichedTableData } from "./useEnrichedTableData";

type HookParams<T> = {
    data?: T;
    isDataFetchSuccess: boolean;
};

export function useLeadsTableResults<T extends LeadsSearchTableData<LeadsSearchRow>>({
    data,
    isDataFetchSuccess,
}: HookParams<T>) {
    const { data: detailedResults } = useActiveTabLeadsDetailedResults({
        rows: data?.rows,
        isRowsFetchSuccess: isDataFetchSuccess,
    });

    return useEnrichedTableData<LeadsSearchRow, T>(data, detailedResults);
}
